<template>
  <div class="flex m-4 shadow-xl rounded bg-black">
    <img
      class="h-auto w-2/12 object-cover mr-3 rounded-l"
      :src="lead.profileImg"
      alt
    />
    <div class="flex flex-col p-2">
      <h1 class="text-4xl font-bold mb-2 text-red-700">{{ lead.fullname }}</h1>
      <h1 class="text-2xl font-semibold mb-2 text-red-700">{{ lead.role }}</h1>
      <p
        class="text-md mb-2 text-white"
      >{{ lead.description }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Lead',
  props: {
    lead: {
      type: Object,
      required: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/credits/Lead.vue